import * as THREE from "three";
import {CBARContext} from "../CBARContext";
import {CBARSurface} from "./CBARSurface";
import {CBARSurfaceType} from "../CBARTypes";
import {CBARImage} from "./CBARImage";

export class CBARDynamicSurface extends CBARSurface {

    public constructor(context: CBARContext, type:CBARSurfaceType, normal:THREE.Vector3, offset:number, mask:HTMLCanvasElement) {

        const maskIndex = context.scene?.geometry.length();
        super(context, maskIndex ? maskIndex : 0);

        this._isSingleMask = true;

        this.plane.normal = normal;
        this.plane.constant = offset;

        this.type = type;

        let maskImage = new CBARImage(context);
        this.images.values['mask'] = maskImage;

        maskImage.image.onload = () => {
            console.log("Loaded mask");
            this.maskTexture?.loadImage(maskImage);
            this.regenerateMeshes(true);
        }

        maskImage.image.src = mask.toDataURL("image/png");
    }
}